import { useMemo } from 'react';
import { Dialog, DialogContent, DialogHeader, DialogTitle } from '@/shared/ui/dialog';
import { OrganizationOverviewData } from '@/shared/types/overviewTypes';
import { TerminalEvolutionChart } from '@/domains/global-dashboard/sections/terminals/TerminalEvolutionChart';

export type TerminalsOverviewDialogProps = {
    open: boolean;
    onOpenChange: (open: boolean) => void;
    organizationOverviewData: OrganizationOverviewData;
};

/** Market-level dashboard: consumption history and service-line evolution from account overview API data. */
export function TerminalsOverviewDialog({
    open,
    onOpenChange,
    organizationOverviewData,
}: TerminalsOverviewDialogProps) {
    const selectedOrganizations = useMemo(() => [organizationOverviewData], [organizationOverviewData]);

    return (
        <Dialog open={open} onOpenChange={onOpenChange}>
            <DialogContent className="max-w-7xl max-h-[95vh] flex flex-col gap-4 overflow-hidden p-4">
                <DialogHeader>
                    <DialogTitle className="text-lg font-semibold">Terminals Overview — {organizationOverviewData.name}</DialogTitle>
                </DialogHeader>

                <TerminalEvolutionChart selectedOrganizations={selectedOrganizations} />
            </DialogContent>
        </Dialog>
    );
}
